import { useEffect } from 'react';

/**
 * Listens for the Escape key on the document. When pressed AND `enabled` is
 * truthy, calls `handler()`. Used by custom-built modals (those that don't use
 * Radix Dialog, which already handles Esc for free).
 *
 * Pattern:
 *   const MyModal = ({ isOpen, onClose }) => {
 *     useEscapeKey(onClose, isOpen);
 *     if (!isOpen) return null;
 *     return <div className="fixed inset-0 …">…</div>;
 *   };
 */
export default function useEscapeKey(handler, enabled = true) {
  useEffect(() => {
    if (!enabled || typeof handler !== 'function') return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape' || e.key === 'Esc') {
        e.stopPropagation();
        handler(e);
      }
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [handler, enabled]);
}
